import PrimaryCell from "../../../../../../../ui/Table/Cells/PrimaryCell";
import PeriodCell from "./PeriodCell";

export const columns = [
  {
    dataField: "id",
    caption: "ID",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 75
  },
  {
    dataField: "isName",
    caption: "Информационная система",
    dataType: "string",
    cellRender: PrimaryCell,
  },
  {
    dataField: "programName",
    caption: "Программа/Модуль/Курс",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "typeName",
    caption: "Тип",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 120
  },
  {
    dataField: "dateBegin",
    caption: "Сроки проведения",
    dataType: "string",
    cellRender: PeriodCell
  }
];
